import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info-small.multi.svg",
  "use": "info-small.multi.svg-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"info-small.multi.svg\"><path d=\"M1 8a7 7 0 1114 0A7 7 0 011 8z\" stroke=\"#1A82CB\" stroke-width=\"2\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 11V8a1 1 0 012 0v3a1 1 0 11-2 0zm1-7a1 1 0 100 2 1 1 0 100-2z\" fill=\"#1A82CB\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol